class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    /* =========================
       DODANE: AJAX refresh hook
       ========================= */
    this._isRefreshing = false;
    document.addEventListener('cart:refresh', () => this.refresh());
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /* ==========================================================
     DODANE NIŻEJ: refresh sekcji cart drawer (bez reload strony)
     ========================================================== */
  async refresh() {
    try {
      if (this._isRefreshing) return;
      this._isRefreshing = true;

      // routes.cart_url jest w Dawn/Craft globalnie dostępne
      // Pobieramy od razu oba fragmenty HTML: drawer + bubble
      const res = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`, {
        headers: { Accept: 'application/json' },
      });

      if (!res.ok) return;

      const sections = await res.json();

      this.renderContents({
        id: null,
        sections: sections,
      });
    } catch (e) {
      console.error('CartDrawer refresh error:', e);
    } finally {
      this._isRefreshing = false;
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
/* ================================
   Upsell AJAX add → Cart Drawer
   ================================ */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cart-upsell-add');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  const cartDrawerEl = document.querySelector('cart-drawer');
  if (!cartDrawerEl || typeof cartDrawerEl.renderContents !== 'function') return;

  btn.disabled = true;

  try {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });

    if (!res.ok) {
      console.error('Upsell add failed', await res.text());
      return;
    }

    const parsedState = await res.json();

    // render drawer
    cartDrawerEl.renderContents(parsedState);

    // usuń is-empty (CSS ukrywa zawartość)
    cartDrawerEl.classList.remove('is-empty');

    // po renderze złap NOWY cart-drawer-items
    setTimeout(() => {
      const freshItemsEl = document.querySelector('cart-drawer-items');
      if (freshItemsEl) freshItemsEl.classList.remove('is-empty');
    }, 0);

  } catch (err) {
    console.error(err);
  } finally {
    btn.disabled = false;
  }
});
